import React, { useState } from 'react';
import { useAtonContext } from '../AtonContext';
import { DeleteAton } from '../Mutations/DeleteAton';
import { AtoN } from '@ais-ui/api-spec/config';
import { useLocalization } from '@ais-ui/locale-management';
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@ais-ui/ui-core';
import { PiDotsThreeVertical } from 'react-icons/pi';
import { noop } from 'lodash';

interface VirtualDropdownMenuProps {
  aton: AtoN;
  onEdit: () => void;
  onDelete: () => void;
  disabled: boolean;
}

interface DisabledVirtualDropdownMenuProps {
  aton: AtoN;
}

export const DisabledVirtualDropdownMenu = ({
  aton,
}: DisabledVirtualDropdownMenuProps) => {
  return (
    <VirtualDropdownMenu
      aton={aton}
      disabled={true}
      onDelete={noop}
      onEdit={noop}
    ></VirtualDropdownMenu>
  );
};
export const EnabledVirtualDropdownMenu = ({
  aton,
}: DisabledVirtualDropdownMenuProps) => {
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const { setMutateType, setShowDialog, setAtonType, setAton } =
    useAtonContext();

  const onDelete = () => {
    setShowDeleteDialog(true);
  };

  const onEdit = () => {
    setAton(aton);
    setMutateType('edit');
    setShowDialog(true);
    setAtonType('virtual');
  };

  return (
    <>
      <VirtualDropdownMenu
        aton={aton}
        disabled={false}
        onDelete={onDelete}
        onEdit={onEdit}
      ></VirtualDropdownMenu>
      <DeleteAton
        aton={aton}
        showDialog={showDeleteDialog}
        setShowDialog={setShowDeleteDialog}
      />
    </>
  );
};
const VirtualDropdownMenu = ({
  aton,
  onEdit,
  onDelete,
  disabled,
}: VirtualDropdownMenuProps) => {
  const { messages } = useLocalization();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          id={`${aton.name?.toLowerCase()}-dropdown-button`}
          size="icon"
          variant="ghost"
          className="h-8 w-8"
          disabled={disabled}
        >
          <PiDotsThreeVertical className="h-6 w-6" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={onEdit}>
          {messages.genericEdit}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onDelete}>
          {messages.genericDelete}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
